export enum OrderingParams {
  START_AT = "start_at",
}

export interface BreakApi {
  uuid: string;
  end_at: number;
  start_at: number;
  created_at: number;
  canceled_at: number;
  is_cancelable: string;
  reason_uuid: string;
  customer_uuid: string;
  is_active: boolean;
  comment: string;
  reason_i18n: string;
}

export interface ReasonApi {
  uuid: string;
  i18n: string;
  text: string;
}

export type BreaksApi = BreakApi[];

export type BreakReasonsApi = ReasonApi[];

export interface BreaksApiQuery {
  customer_uuid: string;
  ordering: OrderingParams.START_AT | string;
}

export interface CreateBreakApiQuery {
  customer_uuid: string;
  reason_uuid: string;
  start_at: number;
  duration: number;
  comment?: string;
}
